__turbopack_context__.v({
  "alertYellow": "ZcVXRG_alertYellow",
  "animateCardPosition": "ZcVXRG_animateCardPosition",
  "black": "ZcVXRG_black",
  "black90": "ZcVXRG_black90",
  "blog": "ZcVXRG_blog",
  "card": "ZcVXRG_card",
  "cardCopy": "ZcVXRG_cardCopy",
  "cardTakeover": "ZcVXRG_cardTakeover",
  "clickable": "ZcVXRG_clickable",
  "cta": "ZcVXRG_cta",
  "cyan": "ZcVXRG_cyan",
  "darkStone": "ZcVXRG_darkStone",
  "delayTransition1": "ZcVXRG_delayTransition1",
  "delayTransition2": "ZcVXRG_delayTransition2",
  "desktopVideo": "ZcVXRG_desktopVideo",
  "fuschiaPunch": "ZcVXRG_fuschiaPunch",
  "hasBackgroundImage": "ZcVXRG_hasBackgroundImage",
  "hasContent": "ZcVXRG_hasContent",
  "hasVideo": "ZcVXRG_hasVideo",
  "illustration": "ZcVXRG_illustration",
  "inCarousel": "ZcVXRG_inCarousel",
  "inner": "ZcVXRG_inner",
  "limeSorbet": "ZcVXRG_limeSorbet",
  "mobileVideo": "ZcVXRG_mobileVideo",
  "olive100": "ZcVXRG_olive100",
  "olive20": "ZcVXRG_olive20",
  "reduceImageSize": "ZcVXRG_reduceImageSize",
  "reverseOrder": "ZcVXRG_reverseOrder",
  "shown": "ZcVXRG_shown",
  "singleCardRow": "ZcVXRG_singleCardRow",
  "softBlack": "ZcVXRG_softBlack",
  "staticImage": "ZcVXRG_staticImage",
  "teal100": "ZcVXRG_teal100",
  "teal20": "ZcVXRG_teal20",
  "triggerPositionAnimation": "ZcVXRG_triggerPositionAnimation",
  "warmStone": "ZcVXRG_warmStone",
  "white": "ZcVXRG_white",
});
